import { ControlValueAccessor } from '@angular/forms';
import { Input, Directive } from '@angular/core';
import { BulkActionConfigModel } from '../../models/bulk-action-config.model';

@Directive()
export abstract class BulkActionFormComponent implements ControlValueAccessor {
    @Input() showErrors: boolean = false;
    @Input() action: BulkActionConfigModel = null;

    @Input() set parameters(theParameters: any) {
        // Child classes will handle their own parameters if they have any
    };

    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    abstract writeValue(fileType: any): void;

    registerOnChange(fn: Function): void {
        this.onModelChange = fn;
    }

    registerOnTouched(fn: Function): void {
        this.onModelTouched = fn;
    }
}
